import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3 mb-2" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["max"]
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-5" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mt-2" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = ["checked"]
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = ["value", "checked", "onChange"]
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Date Opération "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateControl) = $event)),
                name: "dateOperation",
                type: "datetime-local",
                max: _ctx.currentDateTime,
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Date oper."
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.dateControl]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Magasin ", -1)),
              _createVNode(_component_Multiselect, {
                options: _ctx.magasinOptions,
                searchable: true,
                modelValue: _ctx._magasin,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._magasin) = $event)),
                placeholder: "Sélectionner le magasin"
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Fiche de stock ", -1)),
              _createVNode(_component_Multiselect, {
                modelValue: _ctx._fiche,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._fiche) = $event)),
                options: _ctx.produitOptions,
                searchable: true,
                disabled: _ctx.prodEtat,
                placeholder: "Sélectionner une fiche"
              }, null, 8, ["modelValue", "options", "disabled"])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-9" }, [
            _createElementVNode("div", { class: "form-group mt-2" }, [
              _createElementVNode("label", { class: "fw-semibold mb-1" }, " Observation Générale "),
              _createElementVNode("textarea", {
                class: "form-control",
                rows: "1"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "fw-semibold mb-5" }, null, -1)),
              _createElementVNode("button", {
                disabled: (_ctx.selectedItems.length <= 0 || _ctx._fiche == ''),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.valider(_ctx.selectedItems))),
                class: "btn btn-success me-3 mt-10",
                type: "submit"
              }, " Valider tous les mouvements ", 8, _hoisted_14)
            ])
          ])
        ])
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("table", _hoisted_16, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_17, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check form-check-input",
                  checked: _ctx.allChecked,
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                }, null, 40, _hoisted_18)
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date opér. ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " N°Fiche ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client ", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Qté ", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Stock ", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type Opér. ", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Motif ", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Ref. Doc. ", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("th", {
                scope: "col-md-2",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Oservation ", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouvements, (mouvement, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    value: mouvement.id,
                    checked: _ctx.isChecked(mouvement.id),
                    onChange: ($event: any) => (_ctx.toggleItem(mouvement)),
                    class: "form-check form-check-input"
                  }, null, 40, _hoisted_20)
                ]),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.format_date(mouvement?.dateOperation)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(mouvement?.ficheProduit.numFiche), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(mouvement?.produitCondiBon?.bon?.client
                    ? (mouvement.produitCondiBon.bon.client.nomClient && mouvement.produitCondiBon.bon.client.prenomClient
                      ? mouvement.produitCondiBon.bon.client.nomClient + ' ' +
                      mouvement.produitCondiBon.bon.client.prenomClient
                      : mouvement.produitCondiBon.bon.client.raisonSociale || 'Client sans nom')
                    : mouvement?.produitCondiBon?.bon?.fournisseur
                      ? (mouvement.produitCondiBon.bon.fournisseur.nomFournisseur &&
                        mouvement.produitCondiBon.bon.fournisseur.prenomFournisseur
                        ? mouvement.produitCondiBon.bon.fournisseur.nomFournisseur + ' ' +
                        mouvement.produitCondiBon.bon.fournisseur.prenomFournisseur
                        : mouvement.produitCondiBon.bon.fournisseur.raisonSociale || 'Fournisseur sans nom')
                      : 'Aucune entité associée'), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(mouvement.qte) + " " + _toDisplayString(mouvement?.produitCondiBon.uniteMesure), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(mouvement.stockActuel) + " " + _toDisplayString(mouvement?.ficheProduit.conditionnement.libelle), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(mouvement.typeOperation), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(mouvement?.produitCondiBon.bon.motifSuivi?.libelle), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(mouvement?.produitCondiBon.bon.refDoc), 1),
                _createElementVNode("td", _hoisted_29, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((mouvement.observation) = $event),
                    rows: "1"
                  }, null, 8, _hoisted_30), [
                    [_vModelText, mouvement.observation]
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}